import { axios } from "@/services/axios/config";

/**
 * API function to fetch partner pro memberships
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getMemberships = (payload: any, config: any) => {
    return axios.post('works/leroy_memberships/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to change stuts of partner pro membership
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const membershipAction = (payload: any, config: any) => {
    return axios.put('works/leroy_membership_action/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to change stuts of partner pro membership
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const membershipUpdate = (payload: any, config: any) => {
    return axios.put('works/leroy_membership_update/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to activate or terminate a leroy membership contract
 * @param payload
 * @param config
 * @returns { Promise }
 */
export const membershipContractAction = (payload: any, config: any) => {
    return axios.put('works/leroy_membership_contract_action/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to add a comment to a leroy membership
 * @param payload
 * @param config
 * @returns { Promise }
 */
export const membershipAddComment = (payload: any, config: any) => {
    return axios.put('works/leroy_membership_add_comment/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch lead statistics
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getLeadStatistics = (payload: any, config: any) => {
    return axios.post('quotes/lead_statistics/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch pos user details
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getPOSDetails = (config: any) => {
    return axios.get('auth/point_of_sale_user_details/', config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch public POS details by code
 * @param code
 * @returns { Promise }
 */
export const getPublicPointOfSaleByCode = (code: string) => {
    return axios.get('auth/point_of_sale_details/', { params: { code } })
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch partner leads
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getLeads = (payload: any, config: any) => {
    return axios.post('quotes/lead_list_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch partner external business requests
 * @param payload
 * @param config
 * @param page
 * @param pageSize
 * @returns { Promise }
 */
export const getPartnerBrQuotatisList = (payload: any, config: any, page: number = 1, pageSize: number = 10) => {
    return axios.post(`quotes/partner_br_quotatis_list_web/?page=${page}&page_size=${pageSize}`, payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to handle partner external business request actions
 * @param payload
 * @param config
 * @returns { Promise }
 */
export const partnerBrQuotatisAction = (payload: any, config: any) => {
    return axios.post('quotes/partner_br_quotatis_action_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch partner lead details
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getLeadDetails = (payload: any, config: any) => {
    return axios.post('quotes/lead_detail_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch partner lead details
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const uploadLeadFiles = (payload: any, config: any) => {
    return axios.post('quotes/lead_files_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch partner lead details
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const deleteLeadFile = (payload: any, config: any) => {
    return axios.post('quotes/lead_file_delete_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to send partner lead consent reminder
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const resendConsent = (payload: any, config: any) => {
    return axios.post('quotes/lead_consent_retry/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to change partner lead status
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const changeLeadStatus = (payload: any, config: any) => {
    return axios.post('quotes/lead_actions_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to add partner lead comment
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const addLeadComment = (payload: any, config: any) => {
    return axios.post('quotes/lead_add_comment/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch dashboard data
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getDashboardData = (payload: any, config: any) => {
    return axios.post('quotes/lead_dashboard_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch requests dashboard data
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getRequestsDashboardData = (payload: any, config: any) => {
    return axios.post('quotes/partner_br_dashboard_web/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch pro membership details
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getProMembershipDetails = (payload: any, config: any) => {
    return axios.post('works/leroy_membership_details/', payload, config)
        .then((response) => {
            return Promise.resolve(response.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to get POS notifications
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getPOSNotifications = async (payload: any, config: any) => {
    return axios.post('notif/pos_notifications', payload, config)
                .then((response) => {
                    return Promise.resolve(response)
                })
                .catch((err) => {
                    return Promise.reject(err)
                })
}

/**
 * API function to change POS notification status
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const changePOSNotificationStatus = async (payload: any, config: any) => {
    return axios.put('notif/pos_notifications', payload, config)
                .then((response) => {
                    return Promise.resolve(response)
                })
                .catch((err) => {
                    return Promise.reject(err)
                })
}

/**
 * API function to change POS notification status
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getLeroyBusinessRequests = async (payload: any, config: any) => {
    return axios.post('quotes/partner_br_list_web/', payload, config)
                .then((response) => {
                    return Promise.resolve(response)
                })
                .catch((err) => {
                    return Promise.reject(err)
                })
}


/**
 * API function to change POS notification status
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const getLeroyBusinessRequestDetail = async (payload: any, config: any) => {
    return axios.post('quotes/partner_br_detail_web/', payload, config)
                .then((response) => {
                    return Promise.resolve(response)
                })
                .catch((err) => {
                    return Promise.reject(err)
                })
}
